// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__220MB","colBig":"styles_colBig__2wEzq","colSmall":"styles_colSmall__2rsWz"};